<div class="add-to-locker">
  <span>{{ 'locker.detail.add_title' | translate }}</span>
  <div class="qty-selector">
    <button mat-stroked-button class="text-white border-white" (click)="removeQty()">
      <mat-icon>remove</mat-icon>
    </button>
    <mat-form-field appearance="outline">
      <input matInput type="number" min="1" max="100" [(ngModel)]="qty">
    </mat-form-field>
    <button mat-stroked-button class="text-white border-white" (click)="addQty()">
      <mat-icon>add</mat-icon>
    </button>
    <button mat-flat-button color="primary" (click)="save()">{{ 'locker.detail.add_save' | translate }}</button>
  </div>
</div>